import React from 'react';
import { FilePreviewData, MessageStatus } from 'types';
import { AttachmentIcon } from './AttachmentIcon';
import { STooltip } from 'containers/Chat/Chat.styled';
import { SFileContent, SFileName, SFileSize } from '../FilePreview.styled';
import { formatBytes } from 'utils/formatBytes';

interface FileContentProps {
  data: FilePreviewData;
  fileWidth: number;
  status: MessageStatus;
  isError: boolean;
  asMessage: boolean;
}

export const FileContent: React.FC<FileContentProps> = ({
  data,
  fileWidth,
  status,
  isError,
  asMessage,
}) => {
  const iconElement = (
    <AttachmentIcon fileType={data.file_type} status={status} />
  );
  const fileNameElement = (
    <STooltip content={data.file_name} placement="top-start">
      <SFileName width={fileWidth}>{data.file_name}</SFileName>
    </STooltip>
  );
  const fileSizeElement = (
    <SFileSize asMessage={asMessage} isError={isError}>
      {formatBytes(data.file_size)}
    </SFileSize>
  );

  if (asMessage) {
    return (
      <>
        <SFileContent isError={isError}>
          {iconElement}
          {fileNameElement}
        </SFileContent>
        {fileSizeElement}
      </>
    );
  }

  return (
    <>
      {iconElement}
      <SFileContent isError={isError}>
        {fileNameElement}
        {fileSizeElement}
      </SFileContent>
    </>
  );
};
